import { NgModule } from '@angular/core';
import { ComponentsModule } from './components/components.module';
import { PagesModule } from './pages/pages.module';

@NgModule({
  imports: [ComponentsModule, PagesModule],
  exports: [ComponentsModule, PagesModule],
})
export class NgSterilisationModule {}
